//	更新用户数据
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_ORDER_TYPE = 'UPDATE_ORDER_TYPE';
export const UPDATE_LOADING = 'UPDATE_LOADING';



// WEBPACK FOOTER //
// ./src/store/base/mutations-types.js